export default __webpack_public_path__ + "static/834-344edd0a8dae8efbea021dc9709cd7da.gif";